import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Star, MapPin, Wrench } from "lucide-react";

export default function ShopsList() {
  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/shops");
        setShops(res.data);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#09090B]">
      <Navbar />
      <main className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12 py-10">
        <div className="label-eyebrow mb-3">VETTED SHOPS</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter mb-10">Top-rated repair shops.</h1>

        {loading ? (
          <div className="text-zinc-500">Loading...</div>
        ) : shops.length === 0 ? (
          <div className="border border-dashed border-white/10 p-12 text-center text-zinc-500">No shops yet.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {shops.map((s) => (
              <div key={s.user_id} className="card-base p-6" data-testid={`shop-card-${s.user_id}`}>
                <div className="flex items-start justify-between mb-4">
                  <div className="w-12 h-12 bg-[#FF3B30] flex items-center justify-center">
                    <Wrench className="w-5 h-5 text-white" strokeWidth={2.5} />
                  </div>
                  <div className="flex items-center gap-1 text-sm">
                    <Star className="w-4 h-4 text-[#FF9500] fill-[#FF9500]" />
                    <span className="font-heading font-bold">{s.rating_avg || "—"}</span>
                    <span className="text-zinc-500">({s.rating_count || 0})</span>
                  </div>
                </div>
                <h3 className="font-heading text-xl font-bold mb-1">{s.shop_name || s.name}</h3>
                {s.bio && <p className="text-sm text-zinc-400 mb-3 line-clamp-3">{s.bio}</p>}
                {s.specialties?.length > 0 && (
                  <div className="flex flex-wrap gap-1.5 mt-4">
                    {s.specialties.slice(0, 5).map((t) => (
                      <span key={t} className="text-[10px] uppercase tracking-widest border border-white/10 text-zinc-400 px-2 py-0.5">{t}</span>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
